import {
  LEADERBOARD_DESKTOP,
  LEADERBOARD_MOBILE,
  PHOTO_SHARE_DESKTOP,
  PHOTO_SHARE_GALLERY_DESKTOP,
  PHOTO_SHARE_GALLERY_MOBILE,
  PHOTO_SHARE_MOBILE,
  SIDEPANEL,
  TOP_LEADERBOARD_DESKTOP,
} from "./constants";
export const getAdDimensions = (configKey, isLargishAndUp) => {
    switch (configKey) {
        case 'sidePanel':
            return SIDEPANEL;

        case 'photoShare':
            return isLargishAndUp ? PHOTO_SHARE_DESKTOP : PHOTO_SHARE_MOBILE;

        case 'photoShareGallery':
          return isLargishAndUp ? PHOTO_SHARE_GALLERY_DESKTOP : PHOTO_SHARE_GALLERY_MOBILE;

        case 'topLeaderboard':
            return isLargishAndUp ? TOP_LEADERBOARD_DESKTOP : LEADERBOARD_MOBILE;

        default: // leaderboard
          return isLargishAndUp ? LEADERBOARD_DESKTOP : LEADERBOARD_MOBILE;
    }
};
